/* import __COLOCATED_TEMPLATE__ from './project-details-payment.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import { SH_PAYMENT } from 'sh-www/models/sh-payment';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

const CLASS_NAME = 'SH-c-project-details-payment';

class ProjectDetailsPayment extends Component {
  @service('state-managers/application') applicationStateManager;
  @service('commands/sh-payment-commands') shPaymentCommandService;
  @service session;

  get className() {
    return CLASS_NAME;
  }

  get billingRecordsToShow() {
    const buyerChargesToShowSorted = this.args.application.shInvoices.toArray().sort((invoiceA, invoiceB) => invoiceA.createdAt > invoiceB.createdAt);
    const sellerPayoutItemsToShowSorted = this.args.application.shPayments.toArray().sort((invoiceA, invoiceB) => invoiceA.createdAt > invoiceB.createdAt);

    return this.session.currentUser.isBuyer
      ? buyerChargesToShowSorted
      : sellerPayoutItemsToShowSorted
  }

  get totalLabel() {
    return this.session.currentUser.isBuyer ? 'Total billed amount' : 'Total owed amount';
  }

  get sellerTotalAmount() {
    return this.args.application.shPaymentLineItems.reduce((carry, lineItem) => {
      return carry + lineItem.amount;
    }, 0);
  }

  get buyerTotalAmount() {
    return this.args.application.shInvoiceLineItems.reduce((carry, lineItem) => {
      return carry + lineItem.amount;
    }, 0);
  }

  get totalAmount() {
    return this.session.currentUser.isBuyer ? this.buyerTotalAmount : this.sellerTotalAmount;
  }

  get sellerPaidAmount() {
    const sellerPayoutItemsToShow = this.args.application.shPayments;
    if (!sellerPayoutItemsToShow) {
      return 0;
    }

    return sellerPayoutItemsToShow.reduce((carry, shPayment) => {
      return carry + shPayment.paidAmount;
    }, 0);
  }

  get buyerPaidAmount() {
    const invoicesToAdd = this.args.application.shInvoices;
    if (!invoicesToAdd) {
      return 0;
    }

    return invoicesToAdd.reduce((invoiceCarry, shInvoice) => {
      return invoiceCarry + shInvoice.paidAmount;
    }, 0);
  }

  get paidAmount() {
    return this.session.currentUser.isBuyer ? this.buyerPaidAmount : this.sellerPaidAmount;
  }

  get remainingBalance() {
    return Math.max(0, this.totalAmount - this.paidAmount);
  }

  @dropTask
  *cancelExpeditePayment(application, shPayment) {
    try {
      yield this.shPaymentCommandService.cancelExpeditePayment(shPayment, SH_PAYMENT.DEFAULT_INCLUDES(this.session.currentUser));
      this.applicationStateManager.addToast('Expedite removed');
      this.args.loadPaymentData.perform(application);
    } catch (e) {
      handleErrorResponseWithModal(
        this,
        e,
        'Error removing expediting.  Please refresh and try again.',
        'expedite -- error removing expedite payment id : ' + shPayment.id
      );
    }
  }

  @dropTask
  *expeditePayment(application, shPayment) {
    try {
      yield this.shPaymentCommandService.expeditePayment(shPayment, SH_PAYMENT.DEFAULT_INCLUDES(this.session.currentUser));
      this.applicationStateManager.addToast('Expedited payout added');
      this.args.loadPaymentData.perform(application);
    } catch (e) {
      handleErrorResponseWithModal(
        this,
        e,
        'Error expediting payment.  Please refresh and try again.',
        'expedite -- error expediting payment id : ' + shPayment.id
      );
    }
  }
}

export default ProjectDetailsPayment
